import { SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";

/** 寰宇劲乐：能力强化清除成功时令对手睡眠，失败时进入禁用属性技能分支。 */
export const 寰宇劲乐 = new SpecialAttackSkill(
    "寰宇劲乐",
    type.超能,
    [
        "容易打出致命一击，若打出致命一击则下1回合必定先出手",
        "消除对手的能力提升，消除成功令对手睡眠，未触发则令对手2回合内无法使用属性技能",
    ],
    80,
    [
        new Effect(new effect.消除强化(), Timing.onDamage, undefined, [
            new Effect(
                new effect.施加异常状态(new state.睡眠()),
                Timing.triggered,
                undefined,
                [
                    new RoundEffect(
                        Timing.untriggered,
                        2,
                        new effect.属性封印(),
                        Timing.beforeSkillHit,
                        undefined,
                        true,
                        [],
                    ),
                ],
            ),
        ]),
    ],
    3,
    undefined,
    10,
);

export const 五彩音域 = new StatusSkill(
    "五彩音域",
    [
        "4回合内免疫并反弹异常状态",
        "命中后有80%的几率令对手睡眠，未触发则令对手3回合内造成的伤害是正常状态下的1/2",
        "4回合内不受能力下降效果影响",
    ],
    [
        new Effect(
            new effect.施加异常状态(new state.睡眠()),
            Timing.onSkillHit,
            cond.百分之x的几率(80),
        ),
    ],
);

export const 音符之藤 = new StatusSkill(
    "音符之藤",
    [
        "全属性+1，体力高于对手时强化效果翻倍",
        "吸取对手250点体力，连续使用时每次增加100点，最高450点，体力低于对手或遇到天敌时吸取效果翻倍",
        "下2回合先制+2且直接攻击必定致命一击",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若当前体力高于对手),
            Timing.onSkillHit,
        ),
        new Effect(
            new effect.吸取体力(250, 100, 450, cond.or(cond.若对手为自身的天敌, cond.若当前体力低于对手)),
            Timing.onSkillHit,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
);

/** 幻想迷乐：按造成伤害是否超过阈值选择睡眠或后续增伤效果。 */
export const 幻想迷乐 = new SpecialAttackSkill(
    "幻想迷乐",
    type.超能,
    [
        "造成的伤害超过300则令对手睡眠，未触发则免疫下1次异常状态，并且下2回合有65%的概率令对手睡眠",
        "造成的伤害低于300则下1回合造成的伤害提升100%",
    ],
    150,
    [
        new Effect(
            new effect.施加异常状态(new state.睡眠()),
            Timing.onDamage,
            cond.造成的伤害超过x(300),
        ),
        new RoundEffect(
            Timing.onDamage,
            1,
            new effect.增伤(100),
            Timing.beforeDamage,
            undefined,
            false,
            [],
            cond.造成的伤害低于x(300),
        ).nextRound(),
    ],
);

/** 塞壬极乐：回合类效果清除成功后追加百分比吸取。 */
export const 塞壬极乐 = new SpecialAttackSkill(
    "塞壬极乐",
    type.超能,
    [
        "无视对手免疫伤害效果",
        "消除对手的回合类效果，消除成功则对手睡眠，未触发则附加自身最大体力1/3的百分比伤害并恢复等量体力",
        "当回合未击败对手，则回合结束时吸取对手最大体力的1/3",
    ],
    160,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new Effect(
                new effect.吸取体力(({ sbjPet }) => Math.round(sbjPet.最大体力 * (1 / 3))),
                Timing.triggered,
            ),
        ]),
    ],
    undefined,
    true,
);
